import {
  Box,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Divider
} from "@mui/material";
import Typography from "./base/typography";
import React, { useContext, useEffect, useRef, useState } from "react";
import EInfoToolTip from "./_elements/eInfo-tooltip";
import EMapChart from "./_elements/emap-chart";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Exporter from "./_elements/exporter";
import FilterIcon from "../assets/icons/filter";

import flowImgActive from "../assets/images/map-flow-thumb-active.png";
import heatImg from "../assets/images/map-heat-thumb.png";
import APIContext from "../services/api/api";
import UserContext from "../services/user/user";

import messages_de from "../translations/de.json";
import messages_en from "../translations/en.json";
import messages_es from "../translations/es.json";
import messages_fr from "../translations/fr.json";

import { URLS } from "../configuration/urls";

import { FormattedMessage } from "react-intl";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";

export default function EuSalesDistribution() {
  const { getData } = useContext(APIContext);
  const { lang } = useContext(UserContext);
  const { userData } = useContext(EcUserDataContext);

  const mapRef = useRef();

  const [fromToIsLoading, setFromToIsLoading] = useState(true);
  const [mapDataIsLoadign, setMapDataIsLoadign] = useState(true);
  // const [mapTaxIsLoadign, setMapTaxIsLoadign] = useState(true);
  const [mapData, setMapData] = useState({
    heatMapReportDtos: [],
    taxMapReportDtos: []
  });

  // const [mapData, setMapData] = useState([]);
  // const [fromToMapData, setFromToMapData] = useState([
  //   {
  //     fromCountry: "IT",
  //     subReport: [
  //       {
  //         toCountry: "PL",
  //         total_invoice: "323",
  //       },
  //     ],
  //   },
  //   {
  //     fromCountry: "DE",
  //     subReport: [
  //       {
  //         toCountry: "IT",
  //         total_invoice: "323",
  //       },
  //     ],
  //   },
  //   {
  //     fromCountry: "DE",
  //     subReport: [
  //       {
  //         toCountry: "FR",
  //         total_invoice: "323",
  //       },
  //     ],
  //   },
  // ]);
  const [fromToMapData, setFromToMapData] = useState([]);
  // const [taxData, setTaxData] = useState([]);

  const [mapType, setMapType] = useState("heat");
  const [isEmpty, setIsEmpty] = useState(false);

  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };

  useEffect(() => {
    const fetchData = async (url, setDataState, setLoadingState, chartType) => {
      const data = await getData(url, { store: userData.companyId });
      if (typeof data.heatMapReportDtos !== "undefined") {
        setDataState(data);

        data.heatMapReportDtos.length === 0
          ? setIsEmpty(true)
          : setIsEmpty(false);
      } else if (chartType === "flow" && data) {
        setDataState(data.flowmapReportDtos);
      } else {
        setIsEmpty(true);
        setDataState({
          heatMapReportDtos: [],
          taxMapReportDtos: []
        });
        setMapData({
          heatMapReportDtos: [],
          taxMapReportDtos: []
        });
      }
      setLoadingState(false);
    };

    if (userData.companyId) {
      // fetchData(
      //   `dashboard/cart/total-revenue-countryTo`,
      //   setFromToMapData,
      //   setFromToIsLoading
      // );
      fetchData(
        // `dashboard/country-report-year/${userData.companyId}`,
        `${URLS.COUNTRY_REPORT_YEAR}${userData.companyId}`,
        // `dashboard/cart/total-revenue-country`,
        setMapData,
        setMapDataIsLoadign
      );
      fetchData(
        `${URLS.FLOW_MAP_REPORT_YEAR}${userData.companyId}`,
        setFromToMapData,
        setFromToIsLoading,
        "flow"
      );

      // setFromToIsLoading(false);
    }
  }, [userData]);

  function handleMapType(event, newType) {
    if (newType !== null) {
      setMapType(newType);
      setChecked((prev) => !prev);
    }
  }

  // Filter popover
  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  return (
    <Paper
      className={`widget-col-12 widget-row-2 card-main ${isEmpty && "no-data"}`}
      sx={{
        maxWidth: "100%",
        borderRadius: "8px",
        overflow: "hidden"
      }}
      elevation={0}
      data-testid="map_view_box"
    >
      <Box
        sx={{
          p: "10px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Typography
          className={`card-title ${isEmpty && "no-data"}`}
          component="h2"
          sx={{
            fontSize: "20px",
            lineHeight: "28px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center"
          }}
          data-testid="map_view_heading"
        >
          <FormattedMessage id="euSalesDistribution" />
          <EInfoToolTip
            opacity={1}
            darkModeSupport
            status={isEmpty && "noData"}
            data-testid="map_view_tooltip"
            msg={
              <ul className="tooltip-list">
                <li>
                  <FormattedMessage
                    id="kpis.description1"
                    values={{
                      b: (...chunks) => {
                        return <b style={{ fontWeight: "800" }}>{chunks}</b>;
                      },
                      br: <br />
                    }}
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="kpis.description2"
                    values={{
                      br: <br />
                    }}
                  />
                </li>
              </ul>
            }
          />
        </Typography>
        {fromToIsLoading || mapDataIsLoadign ? (
          ""
        ) : (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="select chart type"
              onClick={handleChange}
              disabled={isEmpty}
              data-testid="map_view_filter_button"
            >
              <FilterIcon disabled={isEmpty} />
              {/* <img
                src={FilterIcon}
                style={{
                  width: "18px",
                  height: "18px",
                  objectFit: "contain",
                  opacity: isEmpty && 0.2,
                }}
              /> */}
            </IconButton>
            <Exporter
              isEmpty={isEmpty}
              exportCSV={false}
              downloadButtonTestId="map_view_export_button"
              pngButtonTestId="map_view_png_button"
              fileName={
                mapType === "heat"
                  ? messages[lang]["euSalesDistribution"] + "-Heatmap"
                  : messages[lang]["euSalesDistribution"] + "-Taxmap"
              }
              refVal={mapRef}
              csvLink="export/dashboard/maps/eu-sales-distribution/countries-shares"
              data={
                mapType === "heat"
                  ? mapData.heatMapReportDtos
                  : mapData.taxMapReportDtos
              }
              headers={
                mapType === "heat"
                  ? [
                      {
                        label: messages[lang]["country"],
                        key: "country"
                      },
                      {
                        label: messages[lang]["totalRevenue"] + " (€)",
                        key: "total_revenue"
                      },
                      {
                        label: messages[lang]["totalOrderValue"],
                        key: "invoice_count"
                      },
                      {
                        label: messages[lang]["averageOrderValue"] + " (€)",
                        key: "average_revenue"
                      },
                      {
                        label: messages[lang]["totalCreditNotes"] + " (€)",
                        key: "total_credits"
                      }
                    ]
                  : [
                      { label: messages[lang]["country"], key: "country" },
                      {
                        label: messages[lang]["grossRevenue"] + " (€)",
                        key: "total_invoice"
                      },
                      {
                        label: messages[lang]["netRevenue"] + " (€)",
                        key: "total_revenue"
                      },
                      {
                        label: messages[lang]["vatAmount"] + " (€)",
                        key: "total_VAT"
                      }
                    ]
              }
            />
          </Box>
        )}
      </Box>
      <Divider sx={{ borderWidth: "1px" }} />
      <Box
        sx={{
          p: 0,
          borderTop: "1px solid var(--new-border)",
          position: "relative"
        }}
        ref={mapRef}
      >
        <Collapse
          in={checked}
          sx={{
            position: "absolute",
            top: "0px",
            zIndex: 9,
            width: "100%"
          }}
        >
          <Paper
            elevation={1}
            sx={{
              pb: 3,
              pt: 2,
              pl: 2,
              pr: 2,
              borderRadius: 0
            }}
            className="card-main"
          >
            <ToggleButtonGroup
              value={mapType}
              exclusive
              onChange={handleMapType}
              aria-label="map type"
              sx={{ borderRadius: 0 }}
            >
              <ToggleButton
                className="map-select-item"
                value="tax"
                aria-label="tax map"
                sx={{
                  borderRadius: "8px  !important",
                  display: "block",
                  p: 0,
                  mr: "16px"
                }}
                data-testid="map_view_filter_tax"
              >
                <img src={heatImg} className="map-toggle-img" alt="Tax map" />
                <div className="map-toggle-txt">
                  <FormattedMessage id="taxMap" />
                </div>
              </ToggleButton>
              <ToggleButton
                className="map-select-item"
                value="heat"
                aria-label="heat map"
                sx={{
                  borderRadius: "8px !important",
                  display: "block",
                  p: 0,
                  mr: "16px",
                  ml: "0 !important"
                }}
                data-testid="map_view_filter_heat"
              >
                <img src={heatImg} className="map-toggle-img" alt="Heat map" />
                <div className="map-toggle-txt">
                  {" "}
                  <FormattedMessage id="heatMap" />
                </div>
              </ToggleButton>
              <ToggleButton
                className="map-select-item"
                value="flow"
                aria-label="flow map"
                sx={{
                  borderRadius: "8px  !important",
                  display: "block",
                  p: 0,
                  ml: "0 !important"
                }}
                data-testid="map_view_filter_flow"
              >
                <img
                  // src={mapType === "flow" ? flowImgActive : flowImg}
                  src={flowImgActive}
                  className="map-toggle-img"
                  alt="flow map"
                />
                <div className="map-toggle-txt">
                  {" "}
                  <FormattedMessage id="flowMap" />
                </div>
              </ToggleButton>
            </ToggleButtonGroup>
          </Paper>
        </Collapse>

        <Box
          sx={{
            textAlign: "center",
            opacity: isEmpty && 0.5,
            pointerEvents: isEmpty && "none"
          }}
          className="map"
        >
          {fromToIsLoading === true || mapDataIsLoadign === true ? (
            <CircularProgress />
          ) : typeof mapData !== "undefined" ? (
            <EMapChart
              // mapData={mapData}
              mapData={mapData.heatMapReportDtos}
              fromToData={fromToMapData}
              type={mapType}
              // taxData={mapData}
              taxData={mapData.taxMapReportDtos}
            />
          ) : (
            <FormattedMessage id="noData" />
          )}
        </Box>
      </Box>
    </Paper>
  );
}
